export default  `
  {{ variableForJsTime }} = hmSensor.createSensor(hmSensor.id.TIME)

  function isInvalid(value) {
    return value === 'INVALID'
  }

  function getLunarText() {
    lunar_month = {{ variableForJsTime }}.lunar_month
    lunar_day = {{ variableForJsTime }}.lunar_day
    festival = {{ variableForJsTime }}.getShowFestival()
    festival = isInvalid(festival) ? '' : festival

    if (!isInvalid(lunar_month)) {
      lunarText = lunar_month
      if (!isInvalid(lunar_day)) {
        lunarText = lunarText + lunar_day
      }
    }
    {{ #variable }}
    {{ variable }}.setProperty(hmUI.prop.MORE, {
      text: {{ showLunarWithFestival }} ? (festival || lunarText) : lunarText,
    })
    {{ /variable }}
    {{ #variableForFestival }}
    {{ variableForFestival }}.setProperty(hmUI.prop.MORE, {
      text: festival,
    })
    {{ /variableForFestival }}
  }
`
